import { DatePicker, Tooltip } from "antd";

import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import { useCollaborative } from "../hooks/use-collaborative";
import { useEffect } from "react";
import { useTopic } from "../hooks/use-topics";
dayjs.extend(quarterOfYear);

interface IDateSelectorProps {
  disabled: boolean;
}

export const DateSelector = ({ disabled }: IDateSelectorProps) => {
  const { topicTitle, output, peakAmbitionDate, setPeakAmbitionDate } =
    useTopic();
  const { ydoc, isSynced } = useCollaborative();

  useEffect(() => {
    if (!peakAmbitionDate && output?.additional_data?.peak_ambition_date) {
      setPeakAmbitionDate(output?.additional_data.peak_ambition_date as string);
    }
  }, [peakAmbitionDate, output]);

  useEffect(() => {
    if (isSynced) {
      const yAdditionalData = ydoc.getMap("additional_data");

      const updateAdditionalData = () => {
        setPeakAmbitionDate(
          yAdditionalData.get("peak_ambition_date") as string
        );
      };

      updateAdditionalData();
      yAdditionalData.observeDeep(updateAdditionalData);

      return () => {
        yAdditionalData.unobserveDeep(updateAdditionalData);
      };
    }
  }, [ydoc, isSynced]);

  return (
    <div className="mr-2">
      {topicTitle === "Peak Ambition" && (
        <Tooltip
          title={
            !isSynced
              ? "Loading..."
              : disabled
                ? "Only team owners can set a peak ambition date"
                : ""
          }
        >
          <DatePicker
            disabled={disabled || !isSynced}
            format={"MMMM D, YYYY"}
            onChange={(_, dateString) => {
              const yAdditionalData = ydoc.getMap("additional_data");
              yAdditionalData.set("peak_ambition_date", dateString);
              setPeakAmbitionDate(dateString ? (dateString as string) : null);
            }}
            value={peakAmbitionDate ? dayjs(peakAmbitionDate) : null}
            // placeholder="Peak ambition date"
            className="mt-1 mb-4 w-full"
            style={
              !disabled
                ? { minWidth: "200px" }
                : {
                    backgroundColor: "rgb(239, 247, 255)",
                    minWidth: "200px"
                  }
            }
          />
        </Tooltip>
      )}
    </div>
  );
};
